/* eslint-disable no-undef */
import I18n from 'i18n-js';

I18n.defaultLocale = window.I18N_DEFAULT_LOCALE || 'en';
I18n.locale = window.I18N_LOCALE || 'en';
I18n.fallbacks = true;

window.I18n = I18n;

export default I18n;
